import { handleSidebarBackgrounds } from '~src/sidebar/index';
import { modifyState } from '~src/state';

export const onChangeBackgroundsTagValue = async (event) => {
  if (event.params.data) {
    const sidebarCurrentBackgroundsTag = event.params.data.text;
    modifyState(
      'sidebarCurrentBackgroundsTag',
      sidebarCurrentBackgroundsTag.toLowerCase()
    );
  } else {
    modifyState('sidebarCurrentBackgroundsTag', 'NO_TAG');
  }

  await handleSidebarBackgrounds();
};
